import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';

import './styles/global.css';

import { useAppStore } from './store/useAppStore';


// WebMCP Implementation
declare global {
  interface Navigator {
    modelContext?: {
      registerTool(tool: unknown): void;
    };
  }
}

try {
  navigator.modelContext?.registerTool({
    name: "generateQRCode",
    description: "Generate a QR code containing text or URL",
    inputSchema: {
      type: "object",
      properties: {
        content: { type: "string", description: "The URL or text to encode in the QR code" }
      },
      required: ["content"]
    },
    // eslint-disable-next-line @typescript-eslint/require-await
    execute: async (args: { content: string }) => {
      useAppStore.getState().setContent(args.content);
      return { content: [{ type: "text", text: `Successfully generated QR code for ${args.content}` }] };
    }
  });
} catch {
  console.debug('WebMCP not available');
}

ReactDOM.createRoot((document.getElementById('root') ?? document.body)).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
